export default __webpack_public_path__ + "static/media/about-2.2933faf1.jpg";